import { render, staticRenderFns } from "./partmoduleEdit.vue?vue&type=template&id=c67c83c0&scoped=true&"
import script from "./partmoduleEdit.vue?vue&type=script&lang=js&"
export * from "./partmoduleEdit.vue?vue&type=script&lang=js&"
import style0 from "./partmoduleEdit.vue?vue&type=style&index=0&id=c67c83c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67c83c0",
  null
  
)

export default component.exports